import React, { useState } from 'react';
import Swal from 'sweetalert2';
import { Link, useNavigate } from 'react-router-dom';
import { FaLinkedinIn, FaInstagram, FaFacebookF, FaYoutube,  } from 'react-icons/fa';

import "../Styles/Footer.css";


function Footer() {
  const navigate = useNavigate();
  const [subEmail, setSubEmail] = useState('');
  const [isSubscribed, setIsSubscribed] = useState(false);


const handleSubscribe = async (e) => {
  e.preventDefault();
  try {
    const res = await fetch('https://api.outstandingworkplaces.co/api/subscribers', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email: subEmail })
    });

    if (res.ok) {
      setIsSubscribed(true);   // ✅ show success message
      setSubEmail('');

      // auto hide after 3 sec (optional)
      setTimeout(() => setIsSubscribed(false), 3000);

    } else {
      throw new Error();
    }
  } catch {
    alert("Subscription failed. Try again!");
  }
};

  // Scroll to top and navigate
  const handleLinkClick = (to) => (e) => {
    e.preventDefault();
    navigate(to);
    window.scrollTo({ top: 0, behavior: 'instant' });
  };

  return (
    <>

      <footer className="footer">
        <div className="footer-content-4col">
          {/* Column 1: Logo, Address, Contact */}
          <div className="footer-col">
            <Link to="/" onClick={handleLinkClick('/')}>
              <img src="/New_logo.jpg" alt="Outstanding Workplaces Logo" className="footer-logo" />
            </Link>

      <div className="footer-contact-row footer-desc">
  <p>
    Since 2025, Outstanding Workplaces is a global HR media and employer 
    branding platform that highlights top workplaces and helps organizations 
    build strong, engaging, and high-performing cultures.
  </p>
</div>
            {/* Stay Connected Section */}
            <div className="stay-connected">
              
              <div className="social-icons">
              <div className="social-icons">
 <a
  href="https://www.linkedin.com/company/outstanding-workplaces/"
  target="_blank"
  rel="noopener noreferrer"
  className="linkedin-icon social-icon"
>
  <img src="/icons/linkedinn.png" alt="LinkedIn" className="social-img" />
</a>
</div>

        <a
  href="https://www.instagram.com/outstanding_workplaces?igsh=MW9iOXZqOXo0bjdpNg=="
  target="_blank"
  rel="noopener noreferrer"
  className="instagram-icon social-icon"
>
  <img src="/icons/insta.png" alt="Instagram" className="social-img" />
</a>

       <a
  href="https://www.facebook.com/share/17BpTmYhEg/"
  target="_blank"
  rel="noopener noreferrer"
  className="facebook-icon social-icon"
>
  <img src="/icons/face.png" alt="Facebook" className="social-img" />
</a>
<a
  href="https://youtube.com/@outstandingworkplaces?si=5BYGwdtCvy_73ifL"
  target="_blank"
  rel="noopener noreferrer"
  className="youtube-icon social-icon"
>
  <img src="/icons/you.png" alt="YouTube" className="social-img" />
</a>

              </div>
            </div>

          </div>
         
          {/* Column 2: Useful Links */}
          <div className="footer-col footer-col-useful">
            <h4>Useful Links</h4>
            <ul>
              <li>
                <Link to="/" onClick={handleLinkClick('/')}>
                  <span className="footer-arrow">&#8250;</span> Home
                </Link>
              </li>
              <li>
                <Link to="/what-we-do" onClick={handleLinkClick('/what-we-do')}>
                  <span className="footer-arrow">&#8250;</span> About Us
                </Link>
              </li>
              <li>
                <Link to="/organization-framework" onClick={handleLinkClick('/team')}>
                  <span className="footer-arrow">&#8250;</span> Our Team
                </Link>
              </li>
              <li>
                <Link to="/certified/micro" onClick={handleLinkClick('/certified/micro')}>
                  <span className="footer-arrow">&#8250;</span> Certified Organizations
                </Link>
              </li>
              <li>
                <Link to="/blogs" onClick={handleLinkClick('/blogs')}>
                  <span className="footer-arrow">&#8250;</span> Insights
                </Link>
              </li>
              <li>
                <Link to="/insights" onClick={handleLinkClick('/contact')}>
                  <span className="footer-arrow">&#8250;</span> Contact Us
                </Link>
              </li>
            </ul>
          </div>
           {/* Column 2: Organizations Offering (NEW) */}
          <div className="footer-col footer-org-offering">
            <h4>Core Offerings</h4>
            <ul>
              <li>
                <Link to="/organization-framework" onClick={handleLinkClick('/organization-framework')}>
                  <span className="footer-arrow">&#8250;</span> Organization Framework
                </Link>
              </li>
               <li>
                <Link to="/our-methodology" onClick={handleLinkClick('/our-methodology')}>
                  <span className="footer-arrow">&#8250;</span> Our Methodology
                </Link>
              </li>
              
              <li>
                <Link to="/get-certified" onClick={handleLinkClick('/get-certified')}>
                  <span className="footer-arrow">&#8250;</span> Get Certified
                </Link>
              </li>
               <li>
                <Link to="/get-certified" onClick={handleLinkClick('/voice')}>
                  <span className="footer-arrow">&#8250;</span> Voice Of Employees
                </Link>
              </li>
              

            </ul>
          </div>
          {/* Column 3: Newsletter & Policies */}
          <div className="footer-col footer-col-newsletter">
            <h4>Resources</h4>
           
            <ul className="footer-policies">
              <li>
                <Link to="/usage-guide" onClick={handleLinkClick('/usage-guide')}>
  <span className="footer-arrow">&#8250;</span> Certification Usage Guide
</Link>
              </li>
              <li>
                <Link to="/faqs" onClick={handleLinkClick('/faqs')}>
                  <span className="footer-arrow">&#8250;</span> FAQs
                </Link>
              </li>
              <li>
                <Link to="/privacy-policy" onClick={handleLinkClick('/privacy-policy')}>
                  <span className="footer-arrow">&#8250;</span> Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms-and-conditions" onClick={handleLinkClick('/terms-and-conditions')}>
                  <span className="footer-arrow">&#8250;</span> Terms & Conditions
                </Link>
              </li>
              
            
            </ul>
           <h5 className="footer-subscribe-title">Subscribe to Our Newsletter</h5>

<form className="footer-subscribe-box" onSubmit={handleSubscribe}>
  <input
    type="email"
    placeholder="Enter your email"
    className="footer-subscribe-input"
    value={subEmail}
    onChange={(e) => setSubEmail(e.target.value)}
    required
  />



<button
  type="submit"
  className="footer-subscribe-btn"
>
  Subscribe
</button>




  
</form>
{isSubscribed && (
  <div className="subscribe-success">
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="10" cy="10" r="10" fill="#22c55e"/>
      <path d="M5.5 10.5L8.5 13.5L14.5 7" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
    <span>Thanks for subscribing</span>
  </div>
)}
          </div>
        </div>
       
      </footer>
      <div className="footer-copyright">
          Copyright © 2026 Outstanding Workplaces. All rights reserved.
        </div>
    </>
  );
}

export default Footer;